import { jsxs as o, jsx as l } from "react/jsx-runtime";
const d = (c) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#joomla-colored_svg__a)", children: /* @__PURE__ */ o("g", { clipPath: "url(#joomla-colored_svg__b)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#F9AE41",
            d: "M23.965 3.333a3.158 3.158 0 0 0-6.284-.446l-.032-.017c-2.583-1.165-4.758.898-4.758.898L7.136 9.551l2.274 2.19 4.632-4.55c2.163-2.164 3.34-.7 3.34-.7 1.628 1.376.056 3.004.056 3.004l2.33 2.246c1.903-2.055 2.013-3.849 1.435-5.275a3.16 3.16 0 0 0 2.762-3.133"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EE4035",
            d: "m21.232 17.857.017-.031c1.165-2.583-.898-4.759-.898-4.759l-5.783-5.754-2.19 2.273 4.55 4.632c2.164 2.163.7 3.34.7 3.34-1.376 1.629-3.004.057-3.004.057l-2.246 2.33c2.055 1.902 3.849 2.013 5.275 1.434a3.158 3.158 0 1 0 3.58-3.522"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#4F91CD",
            d: "m14.617 12.47-4.632 4.551c-2.163 2.163-3.34.7-3.34.7-1.628-1.376-.056-3.004-.056-3.004l-2.33-2.246c-1.903 2.055-2.013 3.848-1.435 5.275a3.158 3.158 0 1 0 3.522 3.579l.032.017c2.583 1.165 4.758-.899 4.758-.899l5.755-5.783z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#7AC043",
            d: "M7.098 9.993c-2.163-2.163-.7-3.34-.7-3.34 1.377-1.629 3.005-.057 3.005-.057l2.245-2.33C9.594 2.365 7.8 2.255 6.373 2.833a3.158 3.158 0 1 0-3.578 3.522l-.017.032c-1.165 2.583.898 4.758.898 4.758L9.46 16.9l2.19-2.274z"
          }
        )
      ] }) }),
      /* @__PURE__ */ o("defs", { children: [
        /* @__PURE__ */ l("clipPath", { id: "joomla-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
        /* @__PURE__ */ l("clipPath", { id: "joomla-colored_svg__b", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24.184H0z" }) })
      ] })
    ]
  }
);
export {
  d as default
};
